<div id="accountMobile" class="account-mobile-container text" *ngIf="this._UserHelper.isSignedIn">
  <div class="account-mobile-header">
    <div class="header-left-side">{{ 'MyAccount' | t }} - {{ this._UserHelper?.customerUser?.UserName }}</div>
    <div class="header-right-side" (click)="closeAccountMobile()">
      <image-loader-utils url="close" extraClasses="close-icon"></image-loader-utils>
    </div>
  </div>
  <account-menu-component menuSelect="modalMobil" [userHelper]="this._UserHelper" [UiHelper]="this._UiHelper"></account-menu-component>
  <div class="account-mobile-content-container">
    <slips-component *ngIf="this._UiHelper.accountMobileMenu == 1"></slips-component>
    <account-credit-component *ngIf="this._UiHelper.accountMobileMenu == 2"></account-credit-component>
    <bookings-component *ngIf="this._UiHelper.accountMobileMenu == 3"></bookings-component>
    <ng-container [ngSwitch]="['b500'] | getProductName">
      <ng-container *ngSwitchCase="'b500'">
        <deposit-component *ngIf="this._UiHelper.accountMobileMenu == 4"></deposit-component>
      </ng-container>
      <ng-container *ngSwitchDefault> </ng-container>
    </ng-container>
    <!-- <deposit-component *ngIf="this._UiHelper.accountMobileMenu==4"></deposit-component> -->
    <user-profile-component *ngIf="this._UiHelper.accountMobileMenu == 5"> </user-profile-component>
    <self-limits-component *ngIf="this._UiHelper.accountMobileMenu == 6"></self-limits-component>
    <document-info-upload *ngIf="this._UiHelper.accountMobileMenu == 7"></document-info-upload>
    <document-upload-component *ngIf="this._UiHelper.accountMobileMenu == 8"></document-upload-component>
    <bonus-comp *ngIf="this._UiHelper.accountMobileMenu == 9"></bonus-comp>
    <ng-container *ngIf="this._UiHelper.accountMobileMenu == 10">
      <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
        <ng-container *ngSwitchCase="'wettarena'">
          <pay3000-wettarena-component></pay3000-wettarena-component>
        </ng-container>
        <ng-container *ngSwitchCase="'b500'">
          <pay3000-b500-component></pay3000-b500-component>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <pay3000-b3000-component></pay3000-b3000-component>
        </ng-container>
      </ng-container>
    </ng-container>
    <verification-sow-component *ngIf="this._UiHelper.accountMobileMenu == 11"></verification-sow-component>
  </div>
</div>
